import { IBankAccount } from "@portal/types/api/IBankAccount";
import { IPortfolio } from "@portal/types/api/IPortfolio";

/**
 * Component to handle account selection in the savings robot.
 * The component separates between a cash account and a portfolio (savings account).
 * It also handles the option of creating a new ASK portfolio.
 * @param account
 * @param setSavingsAgreementCashAccount
 * @param setSavingsAgreementPortfolioId
 * @param setShowCreateAskModal
 */
export const OnAccountChange = (
  account: IBankAccount | IPortfolio,
  setSavingsAgreementCashAccount: (cashAccount: string) => void,
  setSavingsAgreementPortfolioId: (portfolioId: string) => void,
  setShowCreateAskModal: (value: boolean) => void,
) => {
  if (IsAccount(account)) {
    setSavingsAgreementCashAccount(account.accountNumber);
    return;
  }

  if (IsNewAskAccout(account)) {
    setShowCreateAskModal(true);
    return;
  }

  setSavingsAgreementPortfolioId(account.portfolioId);
};

function IsAccount(obj: IBankAccount | IPortfolio): obj is IBankAccount {
  return "accountNumber" in obj;
}

function IsNewAskAccout(portfolio: IPortfolio) {
  return portfolio.portfolioId === "0";
}
